<template>
  <div class="p_divide_list">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
      <!-- <div class="top-right">
        <el-button type="text" @click="dropDownScreen" style="margin-right:20px">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div> -->
      <!-- 筛选下拉框 -->
      <!-- <div class="dropDownScreen" v-show="showDropScreen==1">
        <div  class="inputs">
          <div class="formScreenInput" v-if="isActive==0">
            <div>导入名称</div>
            <el-input size="small" v-model="infoQuery.strobjname" placeholder="请输入导入名称"></el-input>
          </div>
          <div class="formScreenInput" v-if="isActive!=0">
            <div>导入名称</div>
            <el-input size="small" v-model="expQuery.custname" placeholder="请输入导入名称"></el-input>
          </div>
          <div class="timeip formScreenInput">
            <div>操作时间</div>
            <el-date-picker style="width:300px!important" v-model="infoQuery.impdate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div> -->
    </div>
    <div class=" main-con p_divide_box">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>雇员</el-breadcrumb-item>
                <el-breadcrumb-item>流程管理</el-breadcrumb-item>
                <el-breadcrumb-item>人才库</el-breadcrumb-item>
                <el-breadcrumb-item>{{actname}}</el-breadcrumb-item>
                <el-breadcrumb-item>分配记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_divide_table">
            <el-table v-loading="listLoading" class="re_table" :data="tableData" style="width:100%">
          <el-table-column align="center" label="序号">
            <template slot-scope="{$index}">
                <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="时间" min-width="110px">
            <template slot-scope="{row}">
                <span>{{row.DtDistDate}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="内容">
            <template slot-scope="{row}">
                <span>{{row.GddistUsername}}分配{{row.ResumeIdcount}}条简历至{{row.BelongUsername}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="{row}">
                <el-button size="mini" class="d_btn" type="primary" plain @click="dtlHandle(row)">查看简历清单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
        </div>
    </div>
    <!-- 查看简历清单弹框 -->
    <el-dialog title="简历清单" :visible.sync="dtlVisible" width="700px" class="res_dialog">
      <el-table v-loading="dtlLoading" :data="tableDtlData" style="width:100%" class="re_table">
          <el-table-column align="center" label="序号">
            <template slot-scope="{$index}">
                <span>{{(Number(dtlQuery.currpage) - 1) * Number(dtlQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="姓名" min-width="110px">
            <template slot-scope="{row}">
                <span>{{row.StrUserName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="手机号" min-width="100px" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrMobile}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="性别">
            <template slot-scope="{row}">
                <span>{{row.BolUserSex}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="期望薪资" min-width="100px">
            <template slot-scope="{row}">
                <span>{{row.StrUserExpectSa}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="意向岗位" min-width="100px" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrJobInf}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange2"
            :current-page.sync="dtlQuery.currpage"
            :page-size="dtlQuery.perpage"
            @size-change="handleSizeChange2"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalDtl"
          ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary"
            @click="dtlVisible = false"
            size="small"
            >关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "./../../common";
export default {
  name: "divideList",
  data() {
    return {
      actname:'',
        listLoading:false,
        tableData:[],
        //下拉筛选
        showDropScreen: -1,
        listQuery: {
            perpage: 10,
            currpage: 1
        },
        dtlVisible:false,
        dtlLoading:false,
        total:0,
        totalDtl:0,
        recordid:'',
        dtlQuery:{
            Recordid:'',
            perpage: 10,
            currpage: 1
        },
        tableDtlData:[]
    }
  },
  created() {
    this.actname = this.$route.query.actname
    this.getList()
  },
  methods: {
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    // 查看简历清单
    dtlHandle(item){
        // console.log('qq',item)
        this.dtlQuery.Recordid = item.Recordid
        this.dtlVisible = true
        this.getDtlList()
    },
    //分页
    handleCurrentChange(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
        this.listQuery.currpage = 1
        this.listQuery.perpage = Number(val)
        this.getList()
    },
    //分页
    handleCurrentChange2(val){
        this.dtlQuery.currpage = Number(val)
        this.getDtlList()
    },
    handleSizeChange2(val) {
        this.dtlQuery.currpage = 1
        this.dtlQuery.perpage = Number(val)
        this.getDtlList()
    },
    // 获取简历清单
    getDtlList(){
        this.dtlLoading = true
        xz.getdistResumerecords(this.dtlQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.tableDtlData = res.msg
              this.totalDtl = res.totalcount
            }
            this.dtlLoading = false
          })
    },
    // 获取列表
    getList(){
        this.listLoading = true
        xz.getdistrecords(this.listQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.tableData = res.msg
              this.total = res.totalcount
            }
            this.listLoading = false
          })
    }
  }
}
</script>


<style scoped>
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>
<style >
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
</style>